<template>
<v-layout justify-center>
<v-data-table
:headers="headers"
:items="escenario" 
:items-per-page="20"
hide-default-footer
>
<template v-slot:top>
  <v-toolbar flat color="white">
    <v-toolbar-title>Parámetros del escenario</v-toolbar-title>
  </v-toolbar>
</template>
<template v-slot:item.value="{ item }">
  <span v-if="item.isEditing===false">{{item.value}}</span>
  <v-text-field v-else class="pa-0 centered-input" v-model="item.value" hide-details single-line></v-text-field>
</template>
<template v-slot:item.actions="{ item }">
  <v-icon :disabled="![1,2].some(r => usuario.groups.includes(r))" v-if="item.isEditing===false" small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
  <v-container v-else>
    <v-icon small class="mr-2" @click="save(item)">mdi-check</v-icon>
    <v-icon small class="mr-2" @click="cancel(item)">mdi-close</v-icon>
  </v-container>
</template>
<template v-slot:no-data>
  No hay datos
</template>
</v-data-table>
</v-layout>
</template>

<script>
  export default {
    computed: {
      prueba() {
        return this.$store.state.prueba
      },
      escenario() {
        return this.$store.state.escenario;
      },
      escenarioRaw() {
        return this.$store.state.escenarioRaw;
      },
      usuario() {
        return this.$store.state.user;
      },
    },
    created () {
      this.initialize(),
      this.$store.dispatch('loadEscenario',{id: this.prueba.id})
    },
    data: () => ({
      dialog: false,
      preValue: undefined,
      headers: [
        {
          text: 'Nombre',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        { text: 'Valor', value: 'value', sortable: false , align: 'middle'},
        { text: 'Unidad', value: 'format', sortable: false , align: 'middle'},
        { text: 'Acciones', value: 'actions', sortable: false, align: 'middle' },
      ],
      desserts: [],
      editedIndex: -1,
      editedEscenario: {},
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
    }),

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    methods: {
      initialize () {
        this.desserts = []
      },

      editItem (item) {
        var editedIndex = this.escenario.indexOf(item)
        item = Object.assign({}, item)
        item.isEditing = true;
        item.preValue = item.value;
        Object.assign(this.escenario[editedIndex], item)
      },

      save (item) {
        item.isEditing = false;
        var editedIndex = this.escenario.indexOf(item)
        Object.assign(this.escenario[editedIndex], item)
        this.escenarioRaw[item['alias']] = item['value'];
        if (!this.escenario.some(element => element.isEditing === true)) {
          this.$store.dispatch('editEscenario', {
            'id': this.escenarioRaw['id'], 
            'item': this.escenarioRaw
          });
        }
      },

      cancel (item) {
        item.isEditing = false;
        item.value = item.preValue;
        var editedIndex = this.escenario.indexOf(item)
        Object.assign(this.escenario[editedIndex], item)
      }
    },
  }
</script>

<style scoped>
  /deep/ .v-text-field{
    width: 40px;
  }
  .centered-input >>> input {
      text-align: center
  }
</style>
